var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      "data-clazz": _vm.model.clazz
    }
  }, [_c("div", {
    staticClass: "panelTitle"
  }, [_vm._v(_vm._s(_vm.i18n["mailTask"]))]), _c("div", {
    staticClass: "panelBody"
  }, [_c("DefaultDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  }), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v(_vm._s(_vm.i18n["mailTask.to"]) + "：")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      disabled: _vm.readOnly,
      value: _vm.model.to
    },
    on: {
      input: function input(value) {
        _vm.onChange("to", value);
      }
    }
  })], 1), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v(_vm._s(_vm.i18n["mailTask.subject"]) + "：")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      disabled: _vm.readOnly,
      value: _vm.model.subject
    },
    on: {
      input: function input(value) {
        _vm.onChange("subject", value);
      }
    }
  })], 1), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v(_vm._s(_vm.i18n["mailTask.content"]) + "：")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      type: "textarea",
      rows: 4,
      disabled: _vm.readOnly,
      value: _vm.model.content
    },
    on: {
      input: function input(value) {
        _vm.onChange("content", value);
      }
    }
  })], 1), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v("步骤：")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      disabled: _vm.readOnly,
      value: _vm.model.step,
      placeholder: "请输入步骤"
    },
    on: {
      input: function input(value) {
        _vm.onChange("step", value);
      }
    }
  })], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };